module.exports = __webpack_public_path__ + "static/media/cgc.5bf234b1.svg";